// extracted by mini-css-extract-plugin
module.exports = {"dotWrapper":"CustomDot_dotWrapper__1KAG_","dot":"CustomDot_dot__1A1FR"};